import { AnalyticsEvents } from "./AnalyticsEvents";
import mixpanel from "mixpanel-browser";

export default class Mixpanel {
  static initialised = false;
  static disabled = false;

  public static init(userToken: string): void {
    mixpanel.init(userToken, {
      batch_requests: true,
      stop_utm_persistence: true,
      opt_out_tracking_by_default: true,
      disable_persistence: true,
      loaded: (localMixpanel) => {
        this.initialised = true;

        localMixpanel.track(AnalyticsEvents.VIEWEDPAGE, {
          pageName: window.location.pathname,
          isFS: true,
        });
      },
    });
    this.track(AnalyticsEvents.MIXPANEL_INIT, { isFS: true });
  }

  public static track(
    eventName: AnalyticsEvents,
    eventProps?: Record<string, unknown>,
    callback?: () => void
  ) {
    if (this.disabled) {
      return;
    }

    if (!this.initialised) {
      console.error("Mixpanel called before init");
    } else {
      try {
        mixpanel.track(
          eventName,
          {
            ...eventProps,
          },
          callback && callback
        );
      } catch (e) {
        return;
      }
    }
  }

  public static opt_in_tracking() {
    mixpanel.opt_in_tracking();
  }

  public static set_disable_persistence(disable: boolean) {
    mixpanel.set_config({ disable_persistence: disable });
  }
}
